import { Mic } from 'lucide-react'
import { mediaShowModule } from './engine/moduleDefinition'

/** F-178 Podcast: shows of audio (or video) episodes, with the shared player. */
export const podcastModule = mediaShowModule('podcast', Mic, 'mic')
